import { sanitizeBoolString, sanitizeNum, sanitizeString } from '../utils';

import { ClientRequestType, ServerVehiclesRequestType } from './types';

export const transformSaveVehiclesRequest = (
  data: ClientRequestType
): ServerVehiclesRequestType => {
  const { values: vehicleData, editableFields } = data;
  const insurableItems = Object.keys(vehicleData).map(vehicleId => {
    const vehicle = vehicleData[vehicleId];
    const vehicleEditability = editableFields[vehicleId];

    return {
      identifier: vehicleId,
      antiTheft: {
        alarm: sanitizeBoolString(vehicle.alarm, vehicleEditability.alarm),
        activeDisable: sanitizeBoolString(
          vehicle.activeDisable,
          vehicleEditability.activeDisable
        ),
        passiveDisable: sanitizeBoolString(
          vehicle.passiveDisable,
          vehicleEditability.passiveDisable
        ),
        recovery: sanitizeBoolString(
          vehicle.recovery,
          vehicleEditability.recovery
        ),
        hasAntiTheftDevice: sanitizeBoolString(
          vehicle.hasAntiTheftDevice,
          vehicleEditability.hasAntiTheftDevice
        ),
      },
      usageDetails: {
        usedInMexico: sanitizeBoolString(
          vehicle.usedInMexico,
          vehicleEditability.usedInMexico
        ),
        availableForNonCoveredDrivers: sanitizeBoolString(
          vehicle.availableForNonCoveredDrivers,
          vehicleEditability.availableForNonCoveredDrivers
        ),
        feeBasedServices: sanitizeBoolString(
          vehicle.feeBasedServices,
          vehicleEditability.feeBasedServices
        ),
        hazmatToolTransport: sanitizeBoolString(
          vehicle.hazmatToolTransport,
          vehicleEditability.hazmatToolTransport
        ),
        usedAsResidence: sanitizeBoolString(
          vehicle.usedAsResidence,
          vehicleEditability.usedAsResidence
        ),
        emergencyServices: sanitizeBoolString(
          vehicle.emergencyServices,
          vehicleEditability.emergencyServices
        ),
      },
      mileage: {
        annual: sanitizeNum(
          vehicle.annualMileage,
          vehicleEditability.annualMileage
        ),
      },
      parkingDetails: {
        inStateParkingDuration: sanitizeString(
          vehicle.parkingDetails.inStateParkingDuration,
          vehicleEditability.parkingDetails.inStateParkingDuration
        ),
        parkingLocationReason: sanitizeString(
          vehicle.parkingDetails.parkingLocationReason,
          vehicleEditability.parkingDetails.parkingLocationReason
        ),
      },
      parkingType: sanitizeString(
        vehicle.parkingType,
        vehicleEditability.parkingType
      ),
      ownership: {
        ownershipType: sanitizeString(
          vehicle.ownershipType,
          vehicleEditability.ownershipType
        ),
        lienholders: vehicleEditability.ownershipType
          ? vehicle.ownershipType === 'owned'
            ? []
            : [
                {
                  name: sanitizeString(
                    vehicle.lienHolder.name,
                    vehicleEditability.lienHolder.name
                  ),
                  address: {
                    addressLine1: sanitizeString(
                      vehicle.lienHolder.addressLine1,
                      vehicleEditability.lienHolder.addressLine1
                    ),
                    addressLine2: sanitizeString(
                      vehicle.lienHolder.addressLine2,
                      vehicleEditability.lienHolder.addressLine2
                    ),
                    city: sanitizeString(
                      vehicle.lienHolder.city,
                      vehicleEditability.lienHolder.city
                    ),
                    postalCode: sanitizeString(
                      vehicle.lienHolder.postalCode,
                      vehicleEditability.lienHolder.postalCode
                    ),
                    state: sanitizeString(
                      vehicle.lienHolder.state,
                      vehicleEditability.lienHolder.state
                    ),
                  },
                },
              ]
          : undefined,
        registeredToApplicant: sanitizeBoolString(
          vehicle.registeredToApplicant,
          vehicleEditability.registeredToApplicant
        ),
      },
      rideshareUse: sanitizeBoolString(
        vehicle.rideshareUse,
        vehicleEditability.rideshareUse
      ),
      usage: sanitizeString(vehicle.usage, vehicleEditability.usage),
      vehicleIdentification: {
        vehicleServicesId: sanitizeString(
          vehicle.vehicleServicesId,
          vehicleEditability.vehicleServicesId
        ),
        partialVin: sanitizeString(
          vehicle.partialVin,
          vehicleEditability.partialVin
        ),
        vin: sanitizeString(vehicle.vin, vehicleEditability.vin),
        year: sanitizeNum(vehicle.year, vehicleEditability.year),
        make: sanitizeString(vehicle.make, vehicleEditability.make),
        model: sanitizeString(vehicle.model, vehicleEditability.model),
        bodyStyle: sanitizeString(
          vehicle.bodyStyle,
          vehicleEditability.bodyStyle
        ),
      },
      garagedAtPrimaryAddress: sanitizeBoolString(
        vehicle.garagedAtPrimaryAddress,
        vehicleEditability.garagedAtPrimaryAddress
      ),
      garagingAddress: {
        addressLine1: sanitizeString(
          vehicle.garagingAddress.addressLine1,
          vehicleEditability.garagingAddress.addressLine1
        ),
        addressLine2: sanitizeString(
          vehicle.garagingAddress.addressLine2,
          vehicleEditability.garagingAddress.addressLine2
        ),
        city: sanitizeString(
          vehicle.garagingAddress.city,
          vehicleEditability.garagingAddress.city
        ),
        postalCode: sanitizeString(
          vehicle.garagingAddress.postalCode,
          vehicleEditability.garagingAddress.postalCode
        ),
        state: sanitizeString(
          vehicle.garagingAddress.state,
          vehicleEditability.garagingAddress.state
        ),
      },
      businessUse: sanitizeBoolString(
        vehicle.businessUse,
        vehicleEditability.businessUse
      ),
      businessUseType: sanitizeString(
        vehicle.businessUseType,
        vehicleEditability.businessUseType
      ),
    };
  });

  return {
    insurableItems,
  };
};
